import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'Comedy Central',
    callsign: 'CCHD',
    logoUrl: networkLogos.comedycentral.logoUrl,
    slug: 'comedy-central',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="CCHD"
        title="Watch Comedy Central live with Fubo"
        networkName="Comedy Central"
      />
    </>
  )
}
